import Client from './client';
import Jobs from './jobs';
import Users from './user';
import Vans from './van';
import Schedules from './schedule';
import Reports from './reports';

export default {
    Client,
    Jobs,
    Users,
    Vans,
    Schedules,
    Reports
}